import React from "react";
import { Col, Row } from "react-bootstrap";
import {
    SiPostman,
    SiJetbrains,
} from "react-icons/si";
import {DiLinux, DiWindows} from "react-icons/di";
import {RxKeyboard} from "react-icons/rx";
import {CgMouse} from "react-icons/cg";
import {SiMacos} from "react-icons/si";

function Toolstack() {
  const labelStyle = { marginTop: "8px", fontSize: "1.2rem", textAlign: "center" };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiWindows />
        <p style={labelStyle}>Windows</p>
      </Col>
        <Col xs={4} md={2} className="tech-icons">
        <DiLinux />
        <p style={labelStyle}>Linux</p>
      </Col>
        <Col xs={4} md={2} className="tech-icons">
        <SiMacos />
        <p style={labelStyle}>MacOs</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJetbrains />
        <p style={labelStyle}>JetBrains</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
        <p style={labelStyle}>Postman</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <RxKeyboard />
        <p style={labelStyle}>Keyboard</p>
      </Col>
        <Col xs={4} md={2} className="tech-icons">
        <CgMouse />
        <p style={labelStyle}>Mouse</p>
      </Col>
    </Row>
  );
}

export default Toolstack;